import { getCurrentInstance } from 'vue';

// 单例存储上下文
const globalContext = {
    $request: null,
    router: null,
    // 初始化上下文（仅需全局执行一次）
    init(ctx) {
        this.$request = ctx.$request;
        this.router = ctx.router;
    },
    // 内部惰性获取上下文（不主动抛错，兼容初始化时机）
    _getContextLazy() {
        // 1. 优先用全局已初始化的实例
        if (this.$request && this.router) {
            return { $request: this.$request, router: this.router };
        }
        // 2. 兜底从当前Vue实例获取
        const instance = getCurrentInstance();
        if (instance) {
            this.$request = instance.proxy?.$request;
            this.router = instance.proxy?.$router;
            return { $request: this.$request, router: this.router };
        }
        // 3. 仍获取不到时返回空（由业务兜底）
        return { $request: null, router: null };
    },
    // 原有严格模式getContext（保留，供需要强校验的场景）
    getContext() {
        const ctx = this._getContextLazy();
        if (!ctx.$request || !ctx.router) {
            throw new Error('全局上下文未初始化，请先在入口文件执行 globalContext.init()');
        }
        return ctx;
    },
    // 原有快捷方法（保留，兼容旧代码）
    getRequest() {
        return this.getContext().$request;
    },
    getRouter() {
        return this.getContext().router;
    }
};

// ===================== 核心新增：直接导出request/router =====================
// 惰性获取request（使用时才执行，避免初始化时机问题）
export const request = new Proxy({}, {
    get(target, prop) {
        const ctx = globalContext._getContextLazy();
        if (!ctx.$request) {
            throw new Error('全局上下文未初始化，请先在入口文件执行 globalContext.init()');
        }
        return ctx.$request[prop];
    },
    apply(target, thisArg, args) {
        const ctx = globalContext._getContextLazy();
        if (!ctx.$request) {
            throw new Error('全局上下文未初始化，请先在入口文件执行 globalContext.init()');
        }
        return ctx.$request(...args);
    }
});

// 惰性获取router（同上）
export const router = new Proxy({}, {
    get(target, prop) {
        const ctx = globalContext._getContextLazy();
        if (!ctx.router) {
            throw new Error('全局上下文未初始化，请先在入口文件执行 globalContext.init()');
        }
        return ctx.router[prop];
    },
    apply(target, thisArg, args) {
        const ctx = globalContext._getContextLazy();
        if (!ctx.router) {
            throw new Error('全局上下文未初始化，请先在入口文件执行 globalContext.init()');
        }
        return ctx.router(...args);
    }
});

// ===================== 原有插件逻辑（不变） =====================
export const GlobalContextPlugin = {
    install(app) {
        app.config.globalProperties.$globalContext = globalContext;
        const appContext = app._context;
        if (appContext.config.globalProperties.$request && appContext.config.globalProperties.$router) {
            globalContext.init({
                $request: appContext.config.globalProperties.$request,
                router: appContext.config.globalProperties.$router
            });
        }
        app.provide('globalContext', globalContext);
    }
};

// 导出单例（保留，兼容旧代码）
export default globalContext;